/**
 * TimelineDayNumbers Component
 *
 * Renders day number row with alternating background colors.
 * Shows the starting day of each week.
 */

import React from 'react'
import { Typography, useTheme } from '@mui/material'

/**
 * TimelineDayNumbers - Day number row with alternating background
 *
 * @param {Object} props
 * @param {Array} props.weeks - Array of week objects with dayNum
 * @param {number} props.weekWidth - Pixels per week
 */
export const TimelineDayNumbers = ({ weeks, weekWidth }) => {
  const theme = useTheme()

  return (
    <>
      {weeks.map((w, i) => (
        <g key={i}>
          <rect
            x={i * weekWidth}
            y={50}
            width={weekWidth}
            height={20}
            fill={i % 2 === 0 ? theme.palette.background.paper : theme.palette.action.hover}
            stroke={theme.palette.divider}
          />
          <foreignObject
            x={i * weekWidth}
            y={50}
            width={weekWidth}
            height={20}
          >
            <Typography
              sx={{
                fontSize: '10px',
                textAlign: 'center',
                lineHeight: '20px',
                overflow: 'hidden',
                whiteSpace: 'nowrap'
              }}
            >
              {w.dayNum}
            </Typography>
          </foreignObject>
        </g>
      ))}
    </>
  )
}
